var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0Clear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 348.1 347.7",
    style: {
      enableBackground: "new 0 0 348.1 347.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.3,239.2c35.5,0,64.3-28.8,64.3-64.3s-28.8-64.3-64.3-64.3S110,139.4,110,174.9S138.8,239.2,174.3,239.2z M174.3,252.5 c-42.8,0-77.6-34.7-77.6-77.6s34.7-77.6,77.6-77.6s77.6,34.7,77.6,77.6S217.2,252.5,174.3,252.5z M182.1,57.7c0,4.9-4,8.9-8.9,8.9 s-8.9-4-8.9-8.9V8.9c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9V57.7z M182.1,338.8c0,4.9-4,8.9-8.9,8.9s-8.9-4-8.9-8.9v-48.9 c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9V338.8z M97,85.6c3.5,3.4,3.5,9.1,0.1,12.5c-3.4,3.5-9.1,3.5-12.5,0.1l-0.1-0.1L50,63.6 c-3.5-3.5-3.5-9.1,0-12.5c3.5-3.5,9.1-3.5,12.5,0L97,85.6L97,85.6z M295.8,284.4c3.5,3.5,3.5,9.1,0,12.5c-3.5,3.5-9.1,3.5-12.5,0 l-34.5-34.5c-3.5-3.4-3.6-9-0.1-12.5c3.4-3.5,9-3.6,12.5-0.1l0.1,0.1L295.8,284.4L295.8,284.4z M261.9,98.2 c-3.4,3.5-9.1,3.5-12.5,0.1c-3.5-3.4-3.5-9.1-0.1-12.5l0.1-0.1l34.5-34.5c3.5-3.5,9.1-3.5,12.5,0c3.5,3.5,3.5,9.1,0,12.5 L261.9,98.2L261.9,98.2z M63.2,296.9c-3.5,3.5-9.1,3.5-12.5,0c-3.5-3.5-3.5-9.1,0-12.5l34.5-34.5c3.4-3.5,9-3.6,12.5-0.1 c3.5,3.4,3.6,9,0.1,12.5l-0.1,0.1L63.2,296.9L63.2,296.9z M290.4,182.7c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h48.8 c4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9H290.4z M8.9,182.7c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9h48.8c4.9,0,8.9,4,8.9,8.9 s-4,8.9-8.9,8.9H8.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Clear);
export default __webpack_public_path__ + "static/media/0_clear.0ed65ac1571e8405ba5677d39d1bb890.svg";
export { ForwardRef as ReactComponent };